import React, {Component} from 'react';
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {withFirestore} from "react-redux-firebase";
import {connect} from "react-redux";
import {UserIsNotAuthenticated} from "../../utils/AuthManager";
import CompanyRegisterForm from "../../components/auth/CompanyRegisterForm";
import EmployeRegisterForm from "../../components/auth/EmployeRegisterForm";
import {NOT_SUBSCRIBED} from "../../utils/subsciptionStatus";
import {WAITING_FOR_DECISION} from "../../utils/employeeStatus";

import {GoogleApiWrapper} from 'google-maps-react';
import {CheckPassword, StateSetterValidator, ValidateEmail} from "../../utils/Validators";
import {COMPANY_DB_PATH, EMPLOYEE_DB_PATH} from "../../constants/DB_PATHS";
import {GeoFirestore} from "geofirestore";
import {BackgroundDiv} from "../../components/Containers";
import {StyledButton} from "../../components/Buttons";
import {CustomInput} from "../../components/Inputs";
import {PROFILE_URL} from "../../constants/URLS";


class Register extends Component {
    constructor() {
        super();
        this.state = {
            email: 'test20@test.com',
            password1: 'Password1234',
            password2: 'Password1234',
            firstN: 'Nagy',
            lastN: 'Jozsef',
            company: true,
            formComplete: false,
        }
    }

    changeValue = (e) => {
        this.setState({[e.target.id]: e.target.value})
    }


    componentWillMount() {
        setTimeout(()=>{
            if(this.props.auth && !this.props.auth.isEmpty){
                this.props.history.push('/profile')
            }
        }, 2000)


    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        StateSetterValidator(
            [
                ValidateEmail(this.state.email),
                !!this.state.firstN,
                !!this.state.lastN,
                CheckPassword(this.state.password1),
                this.state.password1 === this.state.password2,
                this.props.companyRegister.formFilled
            ],
            this.state.formComplete,
            ()=>{
                this.setState({formComplete: !this.state.formComplete})
            })
        if(!this.state.formComplete && this.props.auth && !this.props.auth.isEmpty){
            this.props.history.push(PROFILE_URL)
        }
    }


    render() {
        console.log(this.props)
        //console.log(this.state)
        /*const origins = ['San Francisco CA'];
        const destinations = ['New York NY', '41.8337329,-87.7321554'];
        if(this.props.google && this.props.google.maps){
            let service = new this.props.google.maps.DistanceMatrixService().getDistanceMatrix({
                origins: origins,
                destinations: destinations,
                travelMode: 'DRIVING',
            }, function(response, status) {
                console.log(response)
            });
        }*/

        return (
            <div>

                <BackgroundDiv/>

                <div>
                    <div>email</div>
                    <CustomInput type="email"
                           id={'email'}
                           onChange={this.changeValue}
                           value={this.state.email}
                                 textTransform={'none'}
                    />
                    <div>passw</div>
                    <CustomInput type="password"
                           id={'password1'}
                           onChange={this.changeValue}
                           value={this.state.password1}/>
                    <CustomInput type="password"
                           id={'password2'}
                           onChange={this.changeValue}
                           value={this.state.password2}/>
                    <div>firstn</div>
                    <CustomInput type="text"
                           id={'firstN'}
                           onChange={this.changeValue}
                           value={this.state.firstN}/>
                    <div>lastn</div>
                    <CustomInput type="text"
                           id={'lastN'}
                           onChange={this.changeValue}
                           value={this.state.lastN}/>

                    <br/>
                    <input type="radio" name="company" id={'company'} checked={this.state.company}
                           onChange={() => (this.setState({company: true}))}/>
                    <label htmlFor="company">Company</label>
                    <input type="radio" name="company" id={'employee'} checked={!this.state.company}
                           onChange={() => (this.setState({company: false}))}/>
                    <label htmlFor="employee">Employee</label>

                </div>
                {this.state.company ? <CompanyRegisterForm/> : <EmployeRegisterForm/>}


                <StyledButton
                    disabled={!this.state.formComplete}
                    onClick={() => {
                    this.props.firebase.createUser(
                        {
                            email: this.state.email,
                            password: this.state.password1,
                        },
                        {
                            firstN: this.state.firstN,
                            lastN: this.state.lastN,
                            role: this.state.company ? 'company' : 'employee',
                            creationDate: new Date(),
                            email: this.state.email,
                            fcmToken: [localStorage.getItem('fcmToken')],
                        }
                    ).then(res => {
                        console.log(res)
                        console.log(this.props.auth.uid)
                        this.props.firebase.updateAuth({
                            displayName: `${this.state.firstN} ${this.state.lastN}`
                        })
                        if(this.state.company){
                            console.log('create company')
                            const geofirestore = new GeoFirestore(this.props.firestore);
                            const geocollection = geofirestore.collection(COMPANY_DB_PATH);
                            geocollection.doc(this.props.auth.uid).set({
                                creationDate: new Date(),
                                owner: this.props.auth.uid,
                                companyName: this.props.companyRegister.companyName,
                                companyAddress: this.props.companyRegister.companyAddress,
                                subscriptionStatus: NOT_SUBSCRIBED,
                                // The coordinates field must be a GeoPoint!
                                coordinates: new this.props.firestore.GeoPoint(
                                    this.props.companyRegister.companyAddress.location.lat,
                                    this.props.companyRegister.companyAddress.location.lng,
                                ),
                            })
                            /*this.props.firestore.collection('companies')
                                .doc(this.props.auth.uid).set({
                                creationDate: new Date(),
                                owner: this.props.auth.uid,
                                companyName: this.props.companyRegister.companyName,
                                companyAddress: this.props.companyRegister.companyAddress,
                                subscriptionStatus: NOT_SUBSCRIBED,
                            })*/
                            this.props.firebase.updateProfile({
                                companyId: this.props.auth.uid
                            })
                        } else {
                            console.log('join company')
                            this.props.firestore.collection(EMPLOYEE_DB_PATH)
                                .doc(this.props.auth.uid).set({
                                creationDate: new Date(),
                                employeeCompanyName: this.props.companyRegister.employeeCompanyName,
                                employeeCompanyNameId: this.props.companyRegister.employeeCompanyNameId,
                                employeeStatus: WAITING_FOR_DECISION,
                            })
                            this.props.firebase.updateProfile({
                                companyId: this.props.companyRegister.employeeCompanyNameId,
                                employeeStatus: WAITING_FOR_DECISION,
                            })

                        }


                    }).then(()=>{
                        this.props.history.push('/profile')
                    })
                }}>create user
                </StyledButton>
            </div>
        );
    }
}

export default compose(
    withRouter,
    withFirestore,
    connect(
        // Map redux state to component props
        ({firebase: {auth, profile}}) => ({
            auth,
            profile
        })),
    connect((state) => ({
        companyRegister: state.companyRegister
    })),
    GoogleApiWrapper({
        apiKey: ('AIzaSyArAZSgfZJcC_KiXv4s_WAUPhJnyA8De8s')
    })
)(Register)